import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import withValidatedUser from './containers/withValidatedUser';
import { canSubscribe } from './utils/access';

// L'écran d'abonnement s'adresse à qui n'a jamais payé, que son essai coure encore ou qu'il
// soit fini. Une entreprise qui a déjà une carte au dossier passe par le renouvellement.
//
// ⚠️ La réponse se relit à chaque rendu. Elle était copiée dans l'état au montage, si bien
// qu'un abonnement souscrit dans la foulée laissait l'écran de paiement affiché.
class ProtectedRouteSubscribe extends React.Component {
  render() {
    const { component: Component, user, ...rest } = this.props;
    const allowed = canSubscribe(user);

    return (
      <div>
        <Route
          {...rest}
          render={(props) => (allowed ? <Component {...props} /> : <Redirect to="/" />)}
        />
      </div>
    );
  }
}

export default withValidatedUser(ProtectedRouteSubscribe);
